// Prevent FontAwesome from injecting its stylesheet at runtime,
// which caused hydration mismatches (React #418/#423) because the
// prerendered <head> already contained the styles and FA would append
// them again during client init. We import the CSS statically instead,
// so Vite bundles it into the normal CSS output exactly once.
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";

config.autoAddCss = false;
